import React, { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { NavbarContainer } from './layout/navbar';
import { SidebarContainer } from './layout/sidebar';
import { AuthContext } from '@shared/context/AuthContext';
import Progress from '@shared/component/progress';
import APIService from '@shared/services/api';

export const HomeContainer = () => {
    const { user, isLoading, isProgress } = useContext(AuthContext);
    const [showNav, setShowNav] = useState(true);
    const [showLayout, setShowLayout] = useState(false);

    const getPermissionApi = async () => {
        try {
            const { data } = await APIService.getAll(`user/get/getPermission`, true, false);

            if (data.success) {
                const userData: any = localStorage.getItem('user');
                const user = JSON.parse(userData);
                user['user_role']['user_permissions'] = data?.user_permissions || [];
                localStorage.setItem('user', JSON.stringify(user));
                setTimeout(() => {
                    setShowLayout(true);
                }, 100);
            }
        } catch (error) {}
    };

    useEffect(() => {
        getPermissionApi();
    }, []);

    return (
        <div className="dash_scroll_off">
            <NavbarContainer hideNav={() => setShowNav(!showNav)} />
            {showLayout && (
                <div className="main_content_cover">
                    {showNav && <SidebarContainer />}

                    <div className="main_body_cover" style={{ position: 'relative' }}>
                        {isLoading && <div className="loader"></div>}
                        {isProgress ? (
                            <div className="progress_wrapper">
                                <div className="modal-progress">
                                    <p>
                                        Uploading{' '}
                                        <span>
                                            <img src="assets/images/dotloading.svg" />
                                        </span>
                                    </p>
                                    <Progress />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}

                        <Outlet />
                    </div>
                </div>
            )}
        </div>
    );
};
